"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var AjaxProvider_1 = __importDefault(require("../../functions/AjaxProvider"));
var AppIntegrationsListView_1 = __importDefault(require("./AppIntegrationsListView"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AppIntegrationEditorModal_1 = __importDefault(require("./AppIntegrationEditorModal"));
var LegacyModal_1 = __importDefault(require("./LegacyModal"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var inertia_1 = require("@inertiajs/inertia");
var LEGACY_MODAL_KEY = "hideLegacyModal";
var AppIntegrations = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var resourceType = types_1.ResourceType.INTEGRATION.toLowerCase() + "s";
    var _a = (0, q_play_components_1.useModal)(), isShown = _a.isShown, toggle = _a.toggle;
    var _b = (0, react_1.useState)(null), currentIntegration = _b[0], setCurrentIntegration = _b[1];
    var _c = (0, react_1.useState)(false), showLegacyModal = _c[0], setShowLegacyModal = _c[1];
    var _d = (0, react_1.useState)(false), hasLegacyIntegrations = _d[0], setHasLegacyIntegrations = _d[1];
    var logger = q_play_core_1.logManager.getLogger();
    var openModalToggleHandler = function () {
        setCurrentIntegration(null);
        toggle();
    };
    var onRowClickHandler = function (integration) {
        if (integration.template_type === "webapi") {
            inertia_1.Inertia.visit("/integration/manage/".concat(integration.id));
        }
        else {
            setCurrentIntegration(integration);
            toggle();
        }
    };
    var runLegacyIntegrationsCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        var integrations, hideModal, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getLegacyIntegrations()];
                case 1:
                    integrations = _a.sent();
                    if (integrations.length > 0) {
                        setHasLegacyIntegrations(true);
                        hideModal = localStorage.getItem(LEGACY_MODAL_KEY);
                        if (!hideModal) {
                            setShowLegacyModal(true);
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error fetching legacy integrations:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        runLegacyIntegrationsCheck();
    }, []);
    var handleLegacyModalClose = function () {
        setShowLegacyModal(false);
    };
    return (react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["integration-page"] },
        showLegacyModal && (react_1.default.createElement(LegacyModal_1.default, { isShown: showLegacyModal, onClose: handleLegacyModalClose })),
        react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-end" },
            react_1.default.createElement(q_play_components_1.Button, { size: "small", className: AppIntegrations_module_css_1.default["switch-button"], onClick: function () { return setShowLegacyModal(true); } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleInfo, className: AppIntegrations_module_css_1.default["toggle-icon"] })),
            hasLegacyIntegrations && (react_1.default.createElement(q_play_components_1.Button, { size: "small", className: AppIntegrations_module_css_1.default["switch-button"], title: t("Switch to legacy integrations"), onClick: function () { return window.location.href = "/integrations/legacy"; } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faRepeat, className: AppIntegrations_module_css_1.default["toggle-icon"] }))),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: resourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("New integration"), onClick: openModalToggleHandler, dataCy: "createAppIntegrationButton" })),
            react_1.default.createElement(AppIntegrationEditorModal_1.default, { permissions: props.permissions, isShown: isShown, closeModal: toggle, integration: currentIntegration, setIntegration: setCurrentIntegration, "data-cy": "appIntegrationEditorModal" })),
        react_1.default.createElement("div", { style: { marginBottom: "6rem" } }),
        react_1.default.createElement(react_admin_1.Admin, { dataProvider: (0, AjaxProvider_1.default)("/api"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "app-integrations", list: function () {
                    return react_1.default.createElement(AppIntegrationsListView_1.default, __assign({}, props, { permissions: props.permissions, onRowClick: onRowClickHandler, resourceType: resourceType }));
                } }))));
};
exports.default = AppIntegrations;
